import {createSlice} from '@reduxjs/toolkit';

import {cpcBuilder} from './reducer';

type cpc = {
  id: number;
  start_date: Date | string;
  end_date: Date | string;
  demand_click_count: number;
  hold: boolean;
  state: string;
};

export type CPCState = {
  loading: number;
  confirmPaymentLoading: boolean;
  vendorNumber: number | string;
  cpcHistoryList: {
    cpcs: cpc[];
    page: number;
    size: number;
    total_items: number;
    total_pages: number;
  } | null;
  preorderCPC: {
    min_price: number;
    max_price: number;
    min_click: number;
    max_click: number;
    click_buckets: number[];
    tax_rate: number;
  };
  cpcDetails: {
    id: number;
    state: string;
    renewal?: boolean;
    start_date: Date | string;
    end_date: Date | string;
    active_click_count: number;
    demand_click_count: number;
    hold: boolean;
    used_budget: number;
    unused_budget: number;
    transaction_code: string;
    payment_id: number;
    payment_price: number;
    payment_tax_rate: number;
    payment_total_price: number;
  } | null;
};

const initialState: CPCState = {
  loading: 0,
  confirmPaymentLoading: false,
  vendorNumber: 0,
  preorderCPC: {
    min_price: 0,
    max_price: 0,
    min_click: 0,
    max_click: 0,
    click_buckets: [],
    tax_rate: 0
  },
  cpcHistoryList: {
    cpcs: [],
    page: 1,
    size: 20,
    total_items: 0,
    total_pages: 0
  },
  cpcDetails: null
};

export const cpcSlicer = createSlice({
  name: 'cpc',
  initialState,
  reducers: {},
  extraReducers: cpcBuilder
});

export default cpcSlicer.reducer;
